import angular from 'angular';
import { ActiveSaleService } from 'src/app/features';

export class MigrationHelper {
    static $inject = [
        '$injector',
        '$state'
    ];

    constructor(
        private readonly injector: angular.auto.IInjectorService,
        private readonly $state: any
    ) {
    }

    getActiveSale(): ActiveSaleService {
        return this.injector.get('ActiveSale');
    }

    getCurrentModuleName(): string {
        const arrCurrentModule = this.$state.current.name.split('.');

        return arrCurrentModule[1] !== 'new' 
            ? arrCurrentModule[1]
            : arrCurrentModule[2];
    }
}

angular.module('application').service('migrationHelper', MigrationHelper);